import type { Feature } from "./types";

import chain from "../chain";
import { getEnvValue } from "../utils";

const enabled = getEnvValue("NEXT_PUBLIC_MARKETPLACE_ENABLED");
const configUrl = "/assets/configs/marketplace_config.json";
const submitFormUrl = 'https://opengpu.network/contact';
const suggestIdeasFormUrl = 'https://opengpu.network/contact';

const title = "Marketplace";

const config: Feature<
  ({ configUrl: string } | { api: { endpoint: string; basePath: string } }) & {
    submitFormUrl: string;
    categoriesUrl: string | undefined;
    suggestIdeasFormUrl: string | undefined;
    securityReportsUrl: string | undefined;
    featuredApp: string | undefined;
    banner: { contentUrl: string; linkUrl: string } | undefined;
    graphLinksUrl: string | undefined;
  }
> = (() => {
  if (enabled === "true" && chain.rpcUrls.length > 0 && submitFormUrl) {
    return Object.freeze({
      title,
      isEnabled: true,
      configUrl,
      submitFormUrl,
      categoriesUrl: undefined,
      suggestIdeasFormUrl,
      securityReportsUrl: undefined,
      featuredApp: undefined,
      banner: undefined,
      graphLinksUrl: undefined,
    });
  }

  return Object.freeze({
    title,
    isEnabled: false,
  });
})();

export default config;
